import React from 'react';
import { CkThemeProvider, CkToastProvider } from '@NP-Webber/crm-kit/dist/next/index.js';
import StudyCalendar from './StudyCalendar';

/**
 * לוח שנה in the old design — the same screen inside a light crm-kit scope, tinted with the MUI theme's
 * blue and font (.scal-legacy), so both designs share one calendar.
 */
export default function StudyCalendarLegacy() {
  return (
    <CkThemeProvider style="modern" mode="light" accent="#1565c0" className="scal-legacy">
      <CkToastProvider>
        <StudyCalendar />
      </CkToastProvider>
    </CkThemeProvider>
  );
}
